export default {
      id: "custom-look-usage",
      viewBox: "0 0 64 71",
      url: __webpack_public_path__ + "icons/mvm-icons.svg#custom-look",
      toString: function () {
        return this.url;
      }
    }